import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MediaContext = createContext({ hero: [], portfolio: [], loading: true, refresh: () => {} });

export const MediaProvider = ({ children }) => {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/media`);
      // Prefix URLs with backend base so <video>/<img> load correctly
      // `poster` est préfixé comme `url` : sans cela il reste relatif et ne se charge pas
      // lorsque le frontend et l'API ne partagent pas la même origine.
      setMedia(data.map((m) => ({
        ...m,
        url: `${process.env.REACT_APP_BACKEND_URL}${m.url}`,
        poster: m.poster ? `${process.env.REACT_APP_BACKEND_URL}${m.poster}` : "",
      })));
    } catch (e) {
      setMedia([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const hero = media.filter((m) => m.slot === "hero");
  const about = media.filter((m) => m.slot === "about");
  const portfolio = media.filter((m) => m.slot === "portfolio");

  return (
    <MediaContext.Provider value={{ hero, about, portfolio, loading, refresh }}>
      {children}
    </MediaContext.Provider>
  );
};

export const useMedia = () => useContext(MediaContext);
export const mediaFullUrl = (url) =>
  url?.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;
